import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICMS } from "../cmsModel";

export const getAllCMS = createAsyncThunk("CMS/FindAllCMS", async () => {
  try {
    const response = await axiosApiInstance.post(`${API_URL}/CMS/FindAllCMS`, {
      Name: "",
    });
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching CMS:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const getAllActiveCMS = createAsyncThunk(
  "CMS/FindAllActiveCMS",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CMS/FindAllActiveCMS`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCMS = createAsyncThunk(
  "CMS/InsertCMS",
  async (CMSData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/InsertCMS`,
        CMSData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCMS = createAsyncThunk(
  "CMS/UpdateCMS",
  async (CMSData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/UpdateCMS`,
        CMSData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCMSByID = createAsyncThunk(
  "CMS/FindByIDCMS",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/FindByIDCMS`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result.Name,
        CMSURL: result.CMSURL,
        CMSImage: result.CMSImage,
        CMSImageAlterTag: result.CMSImageAlterTag,
        Template: result.Template,
        MetaDescription: result.MetaDescription,
        MetaKeyword: result.MetaKeyword,
        MetaTitle: result.MetaTitle,
        Images: result.cms_image_details,
        IsActive: result.IsActive ? 1 : 2,
      } as ICMS;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const cmsActiveInactive = createAsyncThunk(
  "CMS/ActiveInActiveCMS",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/ActiveInActiveCMS`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCMS = createAsyncThunk(
  "CMS/DeleteCMS",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(`${API_URL}/CMS/DeleteCMS`, {
        ID,
      });
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting CMS:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const InsertImage = createAsyncThunk(
  "CMS/InsertCMSImage",
  async (imagedata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/InsertCMSImage`,
        imagedata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const UpdateImage = createAsyncThunk(
  "CMS/UpdateCMSImage",
  async (imagedata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/UpdateCMSImage`,
        imagedata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const DeleteImage = createAsyncThunk(
  "CMS/DeleteCMSImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/DeleteCMSImage`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Delete Images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const ImageNameIsAvailabel = createAsyncThunk(
  "CMS/FindByIDCMSImageIsAvailable",
  async (Name: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/FindByIDCMSImageIsAvailable`,
        { Name: Name }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Delete Images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const InsertCMSImage = createAsyncThunk(
  "CMS/AddCMSImage",
  async (imagedata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CMS/AddCMSImage`,
        imagedata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting Images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
